export class LatestQuestionsModel {
  name: number;
  creation?: Date;
  modified?: Date;
  modified_by?: string;
  owner?: string;
  docstatus: number;
  idx: number;
  classname?: string;
  subject?: string;
  chapter?: string;
  topic?: string;
  question?: string;
  marks?: string;
  language?: string;
  _user_tags?: string;
  _comments?: string;
  _assign?: string;
  _liked_by?: string;
  usage_count: number;
  question_te?: string;
  question_ur?: string;
  difficulty?: string;
  cognitive?: string;
  q_no: number;
  old_id?: string;
  id?: string;
  status: string;
  answer_en?: string;
  answer_te?: string;
  answer_ur?: string;
  constructor(
    name: number,
    docstatus: number,
    idx: number,    
    question: string,    
    usage_count: number,
    q_no: number,
    status: string,
    question_te?: string,
    question_ur?: string,
    creation?: Date,
    modified?: Date,
    modified_by?: string,
    owner?: string,
    classname?: string,
    subject?: string,
    chapter?: string,
    topic?: string,
    marks?: string,
    language?: string,
    _user_tags?: string,
    _comments?: string,
    _assign?: string,
    _liked_by?: string,
    difficulty?: string,
    cognitive?: string,
    old_id?: string,    
    id?: string,
    answer_en?: string,
    answer_te?: string,
    answer_ur?: string
  ) {
    this.name = name;
    this.creation = creation;
    this.modified = modified;
    this.modified_by = modified_by;
    this.owner = owner;
    this.docstatus = docstatus;
    this.idx = idx;
    this.classname = classname;
    this.subject = subject;
    this.chapter = chapter;
    this.topic = topic;
    this.question = question;
    this.marks = marks;
    this.language = language;
    this._user_tags = _user_tags;
    this._comments = _comments;
    this._assign = _assign;
    this._liked_by = _liked_by;
    this.usage_count = usage_count;
    this.question_te = question_te;
    this.question_ur = question_ur;
    this.difficulty = difficulty;
    this.cognitive = cognitive;
    this.q_no = q_no;
    this.old_id = old_id;
    this.id = id;
    this.status = status;
    this.answer_en = answer_en;
    this.answer_te = answer_te;
    this.answer_ur = answer_ur;
  }

 
}